
import { data } from 'jquery';
import modal from '../patterns/modal.js';
import PL_utils from '../patterns/pl-utils.js';

const body = document.querySelector('body');
const isEDMode = window.location.href.indexOf('ed=1') > -1;
var instantiatedByEl = false;
const emailModal = document.querySelector('.modal-email-me');

/**
 * email me modal config
 */
const modalHooks = {
  _hasScrolledToBottom: false,
  _addModalError: function (target) {},
  _removeModalError: function (target) {},
  beforeOpen: function (target) {
    PL_utils.addClass('modal-open', body);
    //Dinamically adds id's to prevent html parsing errors
    document.querySelectorAll('[data-temp-id]').forEach((el) => {
      el.setAttribute('id', el.dataset.tempId);
    });
  },
  afterOpen: function (target) {
  },
  onContinue: function (e, target) {
  },
  onCancel: function () {
    return false;
  },
  beforeClose: function () {
    return false;
  },
  afterClose: function () {
    //Removes id's to prevent html parsing errors
    document.querySelectorAll('[data-temp-id]').forEach((el) => {
      el.removeAttribute('id');
    });
    PL_utils.removeClass('modal-open', body);
    //And reset form
    emailModal.querySelectorAll('.form-error').forEach((err) => {
      err.classList.add('hidden');
    });
    emailModal.querySelectorAll('input').forEach(input => {
      input.classList.remove('error');
    })
    let form = document.getElementById('email-me-form');
    form.reset();
    if (instantiatedByEl) {
      instantiatedByEl.focus();
      instantiatedByEl = false;
    }
  },
  setSize: function () {
    return false;
  },
  onScreenshot: function () {
    return false;
  },
  onInit: function (target) {}
};

const modalOpts = {
  enableBackdropClose: true
};

const appplyAccessibility = (ModalEle) => {
  var el_label = ModalEle.querySelector("[data-label]");
  if (el_label != null && !isEDMode) {
    ModalEle.setAttribute("aria-label", el_label.innerHTML);
    ModalEle.setAttribute("role", "dialog");
    ModalEle.setAttribute("aria-modal", "true");
    ModalEle.removeAttribute("hidden");
    ModalEle.removeAttribute("aria-hidden");
    ModalEle.setAttribute("tabIndex", "0");
  }
};

const emailMeModalEle = document.querySelector('.modal-email-me');
const emailMeModal = modal.initModal(emailMeModalEle, modalHooks, modalOpts);
const emailMeModalTriggers = document.querySelectorAll('[data-email-me]');

export default () => {
  PL_utils.eleOnClick(function (e) {
    e.preventDefault();

    appplyAccessibility(emailMeModalEle);
    emailMeModal.showModal();
    emailMeModalEle.focus();
    instantiatedByEl = (e.target);
  }, emailMeModalTriggers);

  //screenshot
  if (isEDMode) {
    if (window.location.search.substring(1).split('&').indexOf('modal=email') > -1) {
      PL_utils.addClass('full-height', emailMeModalEle);
      emailMeModal.showModal();
    }
  }
};
